"use client";
import { Container, createStyles, Skeleton } from "@mantine/core";
const useStyles = createStyles((theme) => ({
  before: {
    "&:after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 50,
      backgroundColor: theme.colors.brandGrey,
      height: "100%",
      width: "90%",
      "@media (max-width: 40em)": {
        width: "90%",
        left: "50%",
        transform: "translateX( -50%)",
      },
      maxWidth: "960px",
      zIndex: "-10",
      borderRadius: "20px",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      top: 160,
      left: 8,
      width: "191px",
      height: "180px",
      backgroundImage: `url(/images/square-texture.png)`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPositionX: "left",

      zIndex: -10,
    },
  },
  titleContent: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 50,
    height: "100%",
    width: "90%",
    "@media (max-width: 40em)": {
      width: "90%",
      left: "50%",
      transform: "translateX( -50%)",
    },
    maxWidth: "960px",
    // zIndex: "-0",
    borderRadius: "20px",
  },
}));
export default function PageWrapperSkeleton({ children }) {
  const { classes } = useStyles();
  return (
    <>
      <Container className="relative">
        <div className={`${classes.before} pt-6 pb-4`}>
          <div className={`${classes.titleContent} py-16 px-5 lg:p-16 `}>
            <Skeleton height={30} width={95} />
            <div className="flex justify-between flex-col lg:flex-row mt-2">
              <div>
                <Skeleton height={50} width={280} className="max-w-[329px]" />
                <div className=" text-sm md:text-[18px] capitalize text-textGrey mt-1">
                  <Skeleton height={20} width={300} className="max-w-[329px]" />
                </div>
              </div>
              <div className="mt-3 lg:mt-0 flex items-center ">
                <div>
                  <Skeleton
                    height={44}
                    width={300}
                    radius="md"
                    className=" search-input md:w-[300px]"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-[230px] lg:mt-[200px] xs:mt-[250px]">
            {children}
          </div>
        </div>
      </Container>
    </>
  );
}
